<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>

<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="card"  @tab-remove='removeTab' :before-leave='Tabever'>
      <el-tab-pane label='添加企业信息' name='1' v-if='!iscompanyDataFlag'>
        <QyxxAdd :userData='userData' @iscompanyDataFn="iscompanyData" :companyData='userData'></QyxxAdd>
      </el-tab-pane>
      <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable" v-else>
        <component :userData='userData' ref="child" v-if="item.name === '1'" :is="item.content"  :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '2'" :is="item.content" @addTab2="addTab2()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '3'" :is="item.content" @addTab3="addTab3()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '4'" :is="item.content" @addTab4="addTab4()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '5'" :is="item.content" @addTab5="addTab5()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '6'" :is="item.content" @addTab6="addTab6()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else-if="item.name === '7'" :is="item.content" @addTab7="addTab7()" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
        <component :userData='userData' ref="child" v-else :is="item.content" @removeTab="removeTab(item.name)" :companyName='companyName'></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import QyxxData from '../qyxx/QyxxData.vue'
import QyzsRyzzLB from './QyxxLB/QyzsRyzzLB.vue'
import QyzsKyxmLB from './QyxxLB/QyzsKyxmLB.vue'
import QyzsKysbLB from './QyxxLB/QyzsKysbLB.vue'
import QyzsCpLB from './QyxxLB/QyzsCpLB.vue'
import QyzsKyyjLB from './QyxxLB/QyzsKyyjLB.vue'
import QyzsZbysLB from './QyxxLB/QyzsZbysLB.vue'
import QyxxAdd from './QyxxAdd/QyxxAdd.vue'
import QyzsRyzzAdd from './QyxxAdd/QyzsRyzzAdd.vue'
import QyzsKyxmAdd from './QyxxAdd/QyzsKyxmAdd.vue'
import QyzsKysbAdd from './QyxxAdd/QyzsKysbAdd.vue'
import QyzsCpAdd from './QyxxAdd/QyzsCpAdd.vue'
import QyzsKyyjAdd from './QyxxAdd/QyzsKyyjAdd.vue'
import QyzsZbysAdd from './QyxxAdd/QyzsZbysAdd.vue'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    QyxxAdd,
    QyxxData,
    QyzsRyzzLB,
    QyzsKyxmLB,
    QyzsKysbLB,
    QyzsCpLB,
    QyzsKyyjLB,
    QyzsZbysLB,
    QyzsRyzzAdd,
    QyzsKyxmAdd,
    QyzsKysbAdd,
    QyzsCpAdd,
    QyzsKyyjAdd,
    QyzsZbysAdd
  },
  data()
  {
    return {
      iscompanyDataFlag: false,
      companyName: '',
      editableTabsValue: '1',
      editableTabs: [
        {
          title: '公司信息',
          name: '1',
          closable: false,
          content: QyxxData
        },
        {
          title: '资质管理',
          name: '2',
          closable: false,
          content: QyzsRyzzLB
        },
        {
          title: '矿业项目',
          name: '3',
          closable: false,
          content: QyzsKyxmLB
        },
        {
          title: '矿业设备',
          name: '4',
          closable: false,
          content: QyzsKysbLB
        },
        {
          title: '矿产品',
          name: '5',
          closable: false,
          content: QyzsCpLB
        },
        {
          title: '矿用药剂',
          name: '6',
          closable: false,
          content: QyzsKyyjLB
        },
        {
          title: '珠宝玉石',
          name: '7',
          closable: false,
          content: QyzsZbysLB
        }
      ],
      addobj2: {
        title: '添加荣誉资质',
        name: '12',
        closable: true,
        content: QyzsRyzzAdd
      },
      addobj3: {
        title: '添加矿业项目',
        name: '13',
        closable: true,
        content: QyzsKyxmAdd
      },
      addobj4: {
        title: '添加矿业设备',
        name: '14',
        closable: true,
        content: QyzsKysbAdd
      },
      addobj5: {
        title: '添加矿产品',
        name: '15',
        closable: true,
        content: QyzsCpAdd
      },
      addobj6: {
        title: '添加矿用药剂',
        name: '16',
        closable: true,
        content: QyzsKyyjAdd
      },
      addobj7: {
        title: '添加珠宝玉石',
        name: '17',
        closable: true,
        content: QyzsZbysAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  },
  async created()
  {
    this.iscompanyData()
  },
  methods: {
    // 判断有没有公司信息
    iscompanyData(companyName)
    {
      if (this.userData.company)
      {
        this.iscompanyDataFlag = true
        this.companyName = this.userData.company
      }
      else if (companyName)
      {
        this.iscompanyDataFlag = true
        this.companyName = companyName
      }
      else
        this.iscompanyDataFlag = false
      this.$store.commit('onIsLb', '1')
    },
    Tabever(activeName, oldActiveName)
    {
      this.$store.commit('onIsLb', activeName)
    },
    addTab1()
    {
      this.editableTabs.push(this.addobj1)
      this.editableTabsValue = this.addobj1.name
    },
    addTab2()
    {
      this.editableTabs.push(this.addobj2)
      this.editableTabsValue = this.addobj2.name
    },
    addTab3()
    {
      this.editableTabs.push(this.addobj3)
      this.editableTabsValue = this.addobj3.name
    },
    addTab4()
    {
      this.editableTabs.push(this.addobj4)
      this.editableTabsValue = this.addobj4.name
    },
    addTab5()
    {
      this.editableTabs.push(this.addobj5)
      this.editableTabsValue = this.addobj5.name
    },
    addTab6()
    {
      this.editableTabs.push(this.addobj6)
      this.editableTabsValue = this.addobj6.name
    },
    addTab7()
    {
      this.editableTabs.push(this.addobj7)
      this.editableTabsValue = this.addobj7.name
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/qyxx/Qyxx.vue